import axios from 'axios'
import config from '../../config/local-config'
import apiConfig from '../../config/api-config'

const notifyMe = (email, productId, captcha) => {
  const version = 'v1'
  const serviceName = 'stocknotification'
  const site = `${config.hydra.site}`
  const { apiURL } = apiConfig
  const stockNotificationEndPoint = `${apiURL}/${version}/${serviceName}`
  const body = {
    email,
    productId,
    inform: '1',
    'g-recaptcha-response': captcha,
    domain: site,
  }

  return axios
    .post(stockNotificationEndPoint, body, { headers: { apiKey: apiConfig.apiKey } })
    .then(({ data }) => (data && data.data && data.data.results
      ? { data: data.data.results }
      : Promise.reject(new Error('Unknow API response'))))
}
export default notifyMe
